export class User{

    constructor(
        public name:string,
        public email:string,
        public password:string,
        public img?:string,
        public role:string = 'USER_ROLE',
        public google?:boolean,
        public _id?:string
        ){}
}


// WEBPACK FOOTER //
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/models/user.model.ts